// Sauyunan Foundation - Static content extracted from official Company Profile PDF
// This file is the source of truth for institutional info (Vision, Mission, Values, etc.)
// Programs, News, Gallery, Publications, Partners, Team are stored in MongoDB (editable via admin CMS).

export const FOUNDATION = {
  legalName: "Yayasan Sauyunan Rahardja Nusantara",
  shortName: "Sauyunan Foundation",
  taglineSundanese: "Silih Asih, Ngawangun Harepan",
  taglineEnglish: "Connecting Hope. Creating Impact.",
  taglineTranslation: "Compassionate Love, Building Hope",
  coreFocus: ["Humanity", "Sustainability", "Future"],
  contact: {
    email: "sauyunan.foundation@gmail.com",
    phones: ["+62 822-2022-0003", "+62 831-3558-0050"],
    address: "Bentang Padalarang Regency No. 13, RT 006/RW 024",
    addressLine2: "Jaya Mekar, Padalarang, Bandung Barat",
    addressLine3: "Jawa Barat, Indonesia 40553",
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3959.3!2d107.4796!3d-6.8399!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sPadalarang!5e0!3m2!1sen!2sid!4v1700000000000",
    socials: {
      instagram: "https://instagram.com/sauyunan.foundation",
      facebook: "https://facebook.com/sauyunan.foundation",
      linkedin: "https://linkedin.com/company/sauyunan-foundation",
      youtube: "https://youtube.com/@sauyunanfoundation",
    },
    officeHours: "Senin – Jumat, 09.00 – 17.00 WIB",
  },
  logo: "/assets/sauyunan-logo.png",
  companyProfilePdf: "/assets/sauyunan-company-profile.pdf",
};

export const ABOUT = {
  executiveSummary:
    "Sauyunan Rahardja Nusantara Foundation (Sauyunan Foundation) merupakan lembaga filantropi, kemanusiaan, dan pembangunan berkelanjutan yang didirikan untuk mendorong terciptanya masyarakat yang sejahtera, tangguh, berdaya, dan berkelanjutan melalui pendekatan kolaboratif yang mengintegrasikan aspek sosial, ekonomi, pendidikan, kesehatan, pangan, lingkungan, serta inovasi.",
  catalystStatement:
    "Sauyunan Foundation hadir sebagai katalisator perubahan sosial yang menghubungkan masyarakat, pemerintah, dunia usaha, akademisi, komunitas, dan mitra pembangunan dalam menciptakan solusi yang terukur, berkelanjutan, dan berdampak luas.",
  history: [
    {
      title: "Lahir dari Keyakinan",
      body:
        "Sauyunan Foundation lahir dari keyakinan bahwa pembangunan yang berkelanjutan harus dimulai dari manusia, didukung oleh kolaborasi, dan diwujudkan melalui tindakan nyata yang mampu menciptakan manfaat lintas generasi.",
    },
    {
      title: "Akar Filosofi Sunda",
      body:
        'Nama "Sauyunan" berasal dari filosofi Sunda yang menggambarkan semangat kebersamaan, gotong royong, solidaritas, dan tanggung jawab bersama dalam membangun kehidupan yang lebih baik.',
    },
    {
      title: "Makna Rahardja",
      body:
        'Kata "Rahardja" melambangkan kesejahteraan, kemakmuran, dan keberlanjutan — pilar-pilar yang menjadi tujuan akhir dari seluruh aktivitas kami.',
    },
    {
      title: "Komitmen Nusantara",
      body:
        '"Nusantara" mencerminkan komitmen organisasi untuk memberikan manfaat bagi seluruh masyarakat Indonesia serta berkontribusi terhadap agenda pembangunan global yang berkelanjutan.',
    },
    {
      title: "Ekosistem Dampak",
      body:
        "Sauyunan Foundation bukan sekadar organisasi yang menjalankan program sosial, melainkan institusi yang membangun ekosistem dampak (Impact Ecosystem) yang menghubungkan kemanusiaan, ketahanan pangan, kesehatan, pendidikan, ekonomi, lingkungan, dan inovasi dalam satu kerangka pembangunan yang terintegrasi.",
    },
  ],
  vision:
    "Menjadi lembaga filantropi dan pembangunan berkelanjutan yang terpercaya, profesional, inovatif, dan berdampak dalam mewujudkan masyarakat yang sejahtera, tangguh, inklusif, serta hidup selaras dengan lingkungan untuk generasi masa kini dan mendatang.",
  mission: [
    "Menyelenggarakan program kemanusiaan dan pemberdayaan masyarakat yang inklusif, responsif, dan berkelanjutan.",
    "Mendorong ketahanan pangan, kesehatan, dan gizi masyarakat melalui pendekatan yang terintegrasi.",
    "Mengembangkan pendidikan, kepemimpinan, keterampilan, dan kapasitas sumber daya manusia.",
    "Memperkuat ekonomi masyarakat melalui kewirausahaan sosial, koperasi, usaha produktif, dan ekonomi berbasis komunitas.",
    "Mendukung pelestarian lingkungan, rehabilitasi lahan, energi terbarukan, serta aksi perubahan iklim.",
    "Mengembangkan inovasi sosial dan teknologi untuk meningkatkan efektivitas pembangunan.",
    "Membangun kemitraan strategis lintas sektor untuk memperluas dampak dan keberlanjutan program.",
  ],
  philosophy: [
    {
      key: "SAUYUNAN",
      title: "Sauyunan",
      subtitle: "Kebersamaan",
      body:
        "Nilai luhur yang mencerminkan kebersamaan dalam bertindak, bekerja, dan bertanggung jawab untuk mencapai tujuan bersama. Pembangunan yang berhasil bukanlah pembangunan yang dilakukan oleh satu pihak, melainkan hasil kolaborasi seluruh elemen masyarakat.",
    },
    {
      key: "SILIH ASIH",
      title: "Silih Asih",
      subtitle: "Saling Mengasihi",
      body:
        "Menumbuhkan kasih sayang, kepedulian, dan empati terhadap sesama sebagai dasar dari seluruh aktivitas kemanusiaan.",
    },
    {
      key: "SILIH ASAH",
      title: "Silih Asah",
      subtitle: "Saling Mengembangkan",
      body:
        "Mengembangkan kapasitas, pengetahuan, keterampilan, dan inovasi untuk menciptakan masyarakat yang mandiri dan berdaya saing.",
    },
    {
      key: "SILIH ASUH",
      title: "Silih Asuh",
      subtitle: "Saling Menjaga",
      body:
        "Menjaga keberlanjutan, membangun perlindungan sosial, dan memastikan manfaat pembangunan dapat dirasakan oleh generasi saat ini maupun generasi mendatang.",
    },
  ],
  values: [
    { key: "humanity", title: "Humanity", body: "Menempatkan manusia sebagai pusat dari seluruh kegiatan dan pengambilan keputusan." },
    { key: "integrity", title: "Integrity", body: "Menjalankan organisasi secara jujur, profesional, transparan, dan bertanggung jawab." },
    { key: "collaboration", title: "Collaboration", body: "Membangun sinergi untuk memperluas dampak dan memperkuat keberlanjutan." },
    { key: "innovation", title: "Innovation", body: "Mengembangkan solusi kreatif terhadap tantangan pembangunan." },
    { key: "sustainability", title: "Sustainability", body: "Menciptakan manfaat yang berkelanjutan bagi masyarakat dan lingkungan." },
    { key: "inclusiveness", title: "Inclusiveness", body: "Memberikan kesempatan yang setara bagi seluruh lapisan masyarakat." },
    { key: "accountability", title: "Accountability", body: "Mengelola sumber daya secara efektif dan dapat dipertanggungjawabkan." },
  ],
  positioning: [
    { title: "Impact Catalyst", body: "Menginisiasi dan mempercepat terciptanya perubahan sosial yang positif." },
    { title: "Community Empowerment Institution", body: "Memperkuat kapasitas dan kemandirian masyarakat." },
    { title: "Sustainable Development Partner", body: "Menjadi mitra strategis bagi pemerintah, dunia usaha, akademisi, dan masyarakat." },
    { title: "Impact Ecosystem Builder", body: "Membangun dan menghubungkan berbagai sumber daya untuk menghasilkan dampak yang lebih luas dan berkelanjutan." },
  ],
  impactModel: [
    { stage: "01", title: "Relief", body: "Memberikan bantuan dan respon terhadap kebutuhan mendesak masyarakat." },
    { stage: "02", title: "Recovery", body: "Mendukung proses pemulihan sosial, ekonomi, dan lingkungan." },
    { stage: "03", title: "Empowerment", body: "Meningkatkan kapasitas dan kemandirian masyarakat." },
    { stage: "04", title: "Sustainability", body: "Membangun sistem yang mampu bertahan dan berkembang secara berkelanjutan." },
    { stage: "05", title: "Transformation", body: "Menciptakan perubahan yang bersifat sistemik dan berdampak jangka panjang." },
  ],
  aspiration2045: [
    "Inovasi untuk Masa Depan",
    "Lingkungan Lestari",
    "Kemanusiaan yang Berdaya",
    "Ekonomi Berkelanjutan",
    "Ketahanan Pangan",
    "Kesehatan untuk Semua",
    "Pendidikan Berkualitas",
  ],
  sdgs: [
    { num: 1, label: "No Poverty" },
    { num: 2, label: "Zero Hunger" },
    { num: 3, label: "Good Health & Well-being" },
    { num: 4, label: "Quality Education" },
    { num: 5, label: "Gender Equality" },
    { num: 8, label: "Decent Work & Economic Growth" },
    { num: 13, label: "Climate Action" },
    { num: 15, label: "Life on Land" },
    { num: 17, label: "Partnerships for the Goals" },
  ],
};

export const IMPACT_STATS = [
  { label: "Bidang Program Strategis", value: 7, suffix: "" },
  { label: "Program Unggulan", value: 5, suffix: "" },
  { label: "Nilai Utama Organisasi", value: 7, suffix: "" },
  { label: "SDGs Terhubung", value: 9, suffix: "+" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Kolaborasi bersama Sauyunan Foundation membuktikan bahwa dampak sosial yang berkelanjutan dimulai dari mendengarkan komunitas.",
    name: "Ibu Siti Aminah",
    role: "Ketua Kelompok Tani, Padalarang",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80",
  },
  {
    quote:
      "Program pendidikan Sauyunan membuka jalan baru bagi anak-anak kami untuk bermimpi dan bertindak. Ini bukan bantuan, ini investasi manusia.",
    name: "Bapak Rahmat Suryana",
    role: "Kepala Sekolah, Bandung Barat",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80",
  },
  {
    quote:
      "Semangat Silih Asih, Silih Asah, Silih Asuh terasa nyata dalam setiap program yang kami jalankan bersama.",
    name: "Dini Pratiwi",
    role: "Relawan Sauyunan",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=80",
  },
];

// Navigation structure - editable (in future can be moved to DB / admin)
export const NAV = [
  { label: "Beranda", to: "/" },
  {
    label: "Tentang",
    to: "/tentang",
    children: [
      { label: "Tentang Yayasan", to: "/tentang" },
      { label: "Sejarah", to: "/tentang#sejarah" },
      { label: "Visi & Misi", to: "/tentang#visi-misi" },
      { label: "Filosofi", to: "/tentang#filosofi" },
      { label: "Nilai-nilai", to: "/tentang#nilai" },
    ],
  },
  {
    label: "Program",
    to: "/program",
    children: [
      { label: "Semua Program", to: "/program" },
      { label: "Humanity & Resilience", to: "/program/humanity-resilience" },
      { label: "Food & Bioeconomy", to: "/program/food-systems-bioeconomy" },
      { label: "Health & Nutrition", to: "/program/health-nutrition" },
      { label: "Education & Leadership", to: "/program/education-leadership" },
      { label: "Green Impact & Climate", to: "/program/green-impact-climate" },
      { label: "Economic Empowerment", to: "/program/economic-empowerment" },
      { label: "Future Innovation", to: "/program/future-innovation" },
    ],
  },
  { label: "Proyek", to: "/proyek" },
  { label: "Impact", to: "/impact" },
  { label: "Berita", to: "/berita" },
  { label: "Galeri", to: "/galeri" },
  { label: "Mitra", to: "/mitra" },
  { label: "Publikasi", to: "/publikasi" },
  { label: "Tim", to: "/tim" },
  { label: "Volunteer", to: "/volunteer" },
  { label: "Donasi", to: "/donasi" },
  { label: "Kontak", to: "/kontak" },
];

export const BANK_ACCOUNTS = [
  { bank: "BCA", accountName: "Yayasan Sauyunan Rahardja Nusantara", accountNumber: "1234-5678-9012" },
  { bank: "Mandiri", accountName: "Yayasan Sauyunan Rahardja Nusantara", accountNumber: "9876-5432-1098" },
  { bank: "BRI", accountName: "Yayasan Sauyunan Rahardja Nusantara", accountNumber: "5555-1234-8888" },
];
